module.exports = __webpack_public_path__ + "img/stoperInPhone@3.8b6c7c02.png";